// @ts-nocheck
import { useOrgModules } from "@/contexts/OrgModulesContext";

export type { ModuleKey, OrgModule } from "@/contexts/OrgModulesContext";

/**
 * Backwards-compatible alias for useOrgModules().
 * Module flags come from the OrgModulesProvider (get_org_modules RPC) and
 * fail OPEN so the UI never hides features from users who actually have them.
 */
export function useModules() {
  const { isEnabled, moduleMap, isLoading } = useOrgModules();
  return { isEnabled, modules: moduleMap, isLoading };
}
